import { useMemo } from 'react';

import {
  GroupedOptions,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import useTagOptions from '@/modules/corporate/modules/tags/hooks/useTagOptions';

export const useTagOptionsQuery = ({
  searchText,
  tagId,
}: {
  tagId: string;
} & UseOptionsQueryParams): UseOptionsQueryReturnType => {
  const { tagOptions, ...rest } = useTagOptions({
    tagId,
    valueText: searchText,
  });

  const groups: GroupedOptions[] = useMemo(() => {
    return [
      {
        id: 'tag',
        options:
          tagOptions?.map((tag) => {
            return {
              value: tag.id,
              label: tag.name,
            };
          }) ?? [],
      },
    ];
  }, [tagOptions]);

  return {
    ...rest,
    groups,
  };
};
